module.exports = __webpack_public_path__ + "img/gwrraSeal@3x.67758d90.webp";